import { createPinia } from 'pinia';
import { Component, createApp, markRaw } from 'vue';
import { OButton, OIcon } from 'ofe-common/components';
import '@globals/Tailwind.css';
import appDirectives from '@globals/Directives';
import appMixin from '@globals/Mixin';
import setCustomPrototypes from '@globals/utilities/SetCustomPrototypes';
import setGlobalEventListeners from '@globals/utilities/SetGlobalEventListeners';
import setWindowProperties from '@globals/utilities/SetWindowProperties';
import vueErrorHandler from '@globals/utilities/VueErrorHandler';
import CustomerApp from './CustomerApp.vue';
import router from './router';

const ComponentsObject = import.meta.glob<{ default: Component & { __name: string } }>(
	'@globals/components/base/*.vue',
	{ eager: true },
);

const pinia = createPinia();

pinia.use(({ store }) => {
	store.$router = markRaw(router);
});

const app = createApp(CustomerApp).use(pinia).use(router);

app.config.errorHandler = vueErrorHandler;

setWindowProperties();
setCustomPrototypes();

/**
 * Zmienia schemat kolorystyczny strony
 */
function addTheme() {
	const { pathname } = window.location;
	if (pathname.startsWith('/konto/moje-zapytania')) { return; }

	const customerPages = ['/konto', '/rejestracja', '/rfp'];
	if (customerPages.find((i) => pathname.startsWith(i))) {
		// TODO: [data-theme]
		document.documentElement.classList.add('theme-customer');
	}
}

addTheme();

for (const value of Object.values(ComponentsObject)) {
	const { name, __name } = value.default;
	app.component(name || __name, value.default);
}

app.component('OButton', OButton);
app.component('OIcon', OIcon);

app.mixin(appMixin);

Object.keys(appDirectives).forEach((name) => {
	app.directive(name, appDirectives[name]);
});

app.mount('#app');

setGlobalEventListeners();
